// import TabsMenu from "components/tabsMenu";
import TabsMenu from "components/tabsMenu";
import { useState, useEffect } from "react";
import GlobalPosition from "assets/unityMenu/GlobalPosition.png";
import LocalPosition from "assets/unityMenu/LocalPosition.png";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import Measurement from "./Measurement";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import { useMeasurements } from "hooks/MeasurementsContext";
import { useUnityActions } from "hooks/unityActions";

const UnityMeasurements = () => {
  const { removeMinifiedTab } = useMinifiedMenu();
  const {
    distanceAndArea,
    volume,
    removeFigure,
    removePoint,
    setPointVisibility,
    setVisibility,
    selectedTab,
    setSelectedTab,
    selectedFigure,
    setSelectedFigure,
    setIsHidden
  } = useMeasurements();
  const { setMeasurementMode } = useUnityActions();
  const [figureToRemove, setFigureToRemove] = useState<null | number>(null);
  const [pointToRemove, setPointToRemove] = useState<{ id: number | null, index: number | null }>({ id: null, index: null });
  const [figureVisibility, setFigureVisibility] = useState<{ id: number | null, isVisible: null | boolean }>({ id: null, isVisible: null });
  const [rotationType, setRotationType] = useState<'local' | 'global'>('local');
  const [volumeVisibility, setVolumeVisibility] = useState<{ id: number | null, index: number | null, isVisible: null | boolean }>({ id: null, index: null, isVisible: null });

  const tabs = [
    {
      isSelected: selectedTab === 0,
      name: "Distance/Area",
      onClickHandler: () => setSelectedTab(0),
    },
    {
      isSelected: selectedTab === 1,
      name: "Volume",
      onClickHandler: () => setSelectedTab(1),
    },
  ];

  const onAddItemClick = () => {
    if (window.vuplex) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "AddFigure", arguments: [selectedTab] });
      window.vuplex.postMessage(message);
    }
  };

  useEffect(() => {
    const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "setMeasurementCalculationMode", arguments: [JSON.stringify(selectedTab === 1 ? "volume" : 'area')] });
    window.vuplex.postMessage(message);

    return () => {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "setMeasurementCalculationMode", arguments: ['none'] });
      window.vuplex.postMessage(message);
    };
  }, [selectedTab]);

  const closeHandler = () => {
    removeMinifiedTab('measurements', 'right');
    setMeasurementMode(false);
  };

  useEffect(() => {
    if (selectedTab === 0) {
      if (distanceAndArea.length > 0) {
        setSelectedFigure(distanceAndArea[0].id);
      } else {
        setSelectedFigure('none');
      }
    }
    if (selectedTab === 1) {
      if (volume.length > 0) {
        setSelectedFigure(volume[0].id);
      } else {
        setSelectedFigure('none');
      }
    }
    if (window.vuplex) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "ChangeTab", arguments: [selectedTab] });
      window.vuplex.postMessage(message);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (figureVisibility.id !== null && figureVisibility.isVisible !== null) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "SetFigureVisibility", arguments: [JSON.stringify(figureVisibility)] });
      window.vuplex.postMessage(message);
      setVisibility({ type: selectedTab, payload: figureVisibility });
    }
  }, [figureVisibility]);

  useEffect(() => {
    if (window.vuplex) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "SelectFigure", arguments: [selectedFigure] });
      window.vuplex.postMessage(message);
    }
  }, [selectedFigure]);

  useEffect(() => {
    if (figureToRemove !== null) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "RemoveFigure", arguments: [figureToRemove] });
      window.vuplex.postMessage(message);
      removeFigure({ id: figureToRemove });
      setFigureToRemove(null);
    }
  }, [figureToRemove]);

  useEffect(() => {
    if (pointToRemove.id !== null && pointToRemove.index !== null) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "RemovePoint", arguments: [JSON.stringify(pointToRemove)] });
      window.vuplex.postMessage(message);
      removePoint({ id: pointToRemove.id, index: pointToRemove.index });
      setPointToRemove({ id: null, index: null });
    }
  }, [pointToRemove]);

  useEffect(() => {
    const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "SetRotationType", arguments: [rotationType] });
    window.vuplex.postMessage(message);
  }, [rotationType]);

  useEffect(() => {
    if (volumeVisibility.id !== null) {
      const message = JSON.stringify({ object: "MeasurementReactUI", type: "MeasurementReactUIController", method: "SetVolumeValueVisibility", arguments: [JSON.stringify(volumeVisibility)] });
      window.vuplex.postMessage(message);
      setPointVisibility(volumeVisibility);
      setVolumeVisibility({ id: null, index: null, isVisible: null });
    }
  }, [volumeVisibility]);

  return (
    <div className="h-full w-full bg-dark/65 p-2 relative flex flex-col">
      {/* Header with tabs and buttons */}
      <div className="w-full flex justify-between items-center">
        <TabsMenu tabs={tabs} />
        <div className="flex gap-2 items-center">
          <button onClick={() => setRotationType('global')} className={rotationType === 'global' ? 'bg-blue/70 rounded p-0.5' : 'p-0.5'}>
            <img src={GlobalPosition} height="26px" width="26px" />
          </button>
          <button onClick={() => setRotationType('local')} className={rotationType === 'local' ? 'bg-blue/70 rounded p-0.5' : 'p-0.5'}>
            <img src={LocalPosition} height="26px" width="26px" />
          </button>
          <button
            className="bg-blue px-1 py-1 ml-2 h-[28px] rounded-md cursor-pointer grid place-content-center"
            onClick={closeHandler}
          >
            <FiX size={20} />
          </button>
        </div>
      </div>

      {/* Scrollable measurements container */}
      <div className="flex-1 overflow-y-auto py-2">
        <div className="flex flex-col gap-2 w-full pb-20">
          {selectedTab === 0 && distanceAndArea.map((item, index) => (
            <Measurement data={item} setIsHidden={setIsHidden} type="distanceAndArea" key={index} setSelectedFigure={setSelectedFigure} selectedFigure={selectedFigure} setFigureToRemove={setFigureToRemove} setPointToRemove={setPointToRemove} setFigureVisibility={setFigureVisibility} setVolumeVisibility={setVolumeVisibility} />
          ))}
          {selectedTab === 1 && volume.map((item, index) => (
            <Measurement data={item} setIsHidden={setIsHidden} type="volume" key={index} setSelectedFigure={setSelectedFigure} selectedFigure={selectedFigure} setFigureToRemove={setFigureToRemove} setPointToRemove={setPointToRemove} setFigureVisibility={setFigureVisibility} setVolumeVisibility={setVolumeVisibility} />
          ))}
        </div>
      </div>

      {/* Fixed add button */}
      <div className="fixed bottom-0 p-2">
        <button className="bg-blue-500 rounded-full p-2 shadow-lg" onClick={() => onAddItemClick()}>
          <FaPlus size={25} />
        </button>
      </div>
    </div>
  );
};

export default UnityMeasurements;